import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { formatTime } from '../../lib/utils'
import { BoatIndicator } from '../ui/BoatIndicator'

interface BestLapBannerProps {
  pilotName: string
  boatNumber: number
  boatColor: string
  lapTime: number
  isVisible: boolean
}

export function BestLapBanner({
  pilotName,
  boatNumber,
  boatColor,
  lapTime,
  isVisible,
}: BestLapBannerProps) {
  const [shouldShow, setShouldShow] = useState(isVisible)

  useEffect(() => {
    if (isVisible) {
      setShouldShow(true)
      const timer = setTimeout(() => setShouldShow(false), 4000)
      return () => clearTimeout(timer)
    }
  }, [isVisible])

  return (
    <AnimatePresence>
      {shouldShow && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: -50 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: -50 }}
          transition={{ type: 'spring', stiffness: 100 }}
          className="fixed top-10 left-1/2 -translate-x-1/2 z-50"
        >
          <div className="bg-gradient-to-r from-tropical-green via-paradise-blue to-sunny-yellow p-1 rounded-xl">
            <div className="bg-palm-dark rounded-lg px-8 py-4 flex items-center gap-4 backdrop-blur-sm">
              <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 1.5, repeat: Infinity }}
                className="text-3xl"
              >
                🏁
              </motion.div>

              <div className="flex flex-col gap-1">
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="font-fredoka font-700 text-2xl text-transparent bg-clip-text bg-gradient-to-r from-tropical-green to-paradise-blue"
                >
                  BEST LAP!
                </motion.div>
                <div className="text-sm text-sand-light">
                  {pilotName} - {formatTime(lapTime)}
                </div>
              </div>

              <BoatIndicator
                boatNumber={boatNumber}
                color={boatColor}
                size="sm"
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
